/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `nacht`
};

const en_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `night`
};

const es_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `noche`
};

const fr_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `nuit`
};

const it_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `notte`
};

const nl_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `nacht`
};

const pt_date_range_picker__night_count_placeholder__one = /** @type {(inputs: {}) => string} */ () => {
	return `noite`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.date_range_picker__night_count_placeholder__one(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("date_range_picker__night_count_placeholder__one", locale)
	if (locale === "de") return de_date_range_picker__night_count_placeholder__one(inputs)
	if (locale === "en") return en_date_range_picker__night_count_placeholder__one(inputs)
	if (locale === "es") return es_date_range_picker__night_count_placeholder__one(inputs)
	if (locale === "fr") return fr_date_range_picker__night_count_placeholder__one(inputs)
	if (locale === "it") return it_date_range_picker__night_count_placeholder__one(inputs)
	if (locale === "nl") return nl_date_range_picker__night_count_placeholder__one(inputs)
	return pt_date_range_picker__night_count_placeholder__one(inputs)
};